import SearchOutlined from '@ant-design/icons/SearchOutlined';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import Space from 'antd/lib/space';
import React, { useRef } from 'react';
import Highlighter from 'react-highlight-words';

let searchText;
let searchedColumn;

export const SearchTemplate = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  dataIndex,
}) => {
  const searchInput = useRef(null);

  const handleSearch = (
    selectedKeys,
    confirm,
    index,
    clearFilters = null,
    isReset = false,
  ) => {
    if (!isReset) {
      confirm();
      searchText = selectedKeys[0].toLowerCase();
      searchedColumn = index;
    } else {
      clearFilters();
      searchText = '';
      searchedColumn = index;
      confirm();
    }
  };

  return (
    <div
      style={{
        padding: 8,
      }}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <Input
        ref={searchInput}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
        size='middle'
        style={{
          marginBottom: 8,
          display: 'block',
        }}
      />
      <Space>
        <Button
          type='primary'
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          size='small'
          style={{
            width: 90,
          }}
        >
          Search
        </Button>
        <Button
          onClick={() =>
            clearFilters &&
            handleSearch(selectedKeys, confirm, dataIndex, clearFilters, true)
          }
          size='small'
          style={{
            width: 90,
          }}
        >
          Reset
        </Button>
      </Space>
    </div>
  );
};

export const getColumnSearchProps = (dataIndex) => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <SearchTemplate
      setSelectedKeys={setSelectedKeys}
      selectedKeys={selectedKeys}
      confirm={confirm}
      clearFilters={clearFilters}
      dataIndex={dataIndex}
    />
  ),
  filterIcon: (filtered) => (
    <SearchOutlined
      style={{
        color: filtered ? '#1890ff' : undefined,
      }}
    />
  ),
  onFilter: (value, record) => {
    if (record[dataIndex]) {
      return record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase());
    }
  },
  render: (text) =>
    searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{
          backgroundColor: '#ffc069',
          padding: 0,
        }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text ? text.toString() : ''}
      />
    ) : (
      text
    ),
});
